
<template lang="pug">
    .z-check(v-bind:class="{'has-error': error && error.length, 'is-dirty': isDirty, 'disabled': $props.disabled}")
        input(
            type="checkbox" 
            v-model="valModel" 
            v-bind:value="val"
            v-bind:id="$props.id" 
            v-bind:name="$props.name" 
            v-bind:disabled="$props.disabled"
            v-on:click.prevent.stop="toggleCheck"
        )
        label(v-html="$props.label" v-bind:for="$props.id" v-on:click.prevent.stop="toggleCheck")
        span.z-error(v-if="error") {{error}}
</template>
<script>
    export default {
        name: 'z-check',
        props: {
            id: {
                type: String,
                default: 'z-check'
            },
            name: {
                type: String,
                default: 'z-check'
            },
            label: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            },
            error: {
                type: String,
                default: ''
            },
            model: {
                type: [String, Number, Boolean, Array],
                default: () => false
            },
            value: {
                type: [String, Number, Boolean],
                default: () => false
            },
            dirty: {
                type: Boolean,
                default: false
            }
        },
        model: {
            prop: 'model',
            event: 'change'
        },
        data() {
            return {
                isDirty: false,
                focus: false,
                val: false,
                valModel: false,
                isSelected: false
            }
        },
        created() {
            this.init();
        },
        watch: {
            '$props.model': {
                deep: true,
                handler(newVal, oldVal) {
                    this.init();
                }
            },
            'valModel': {
                deep: true,
                handler(newVal, oldVal) {
                    this.$emit('change', newVal);
                }
            }
        },
        computed: {
        },
        methods: {
            init() {
                this.val = this.$props.value;

                if (typeof this.$props.model === 'object' && Array.isArray(this.$props.model)) {
                    if (JSON.stringify(this.valModel) !== JSON.stringify(this.$props.model))
                        this.valModel = Object.assign([], this.$props.model);
                } else if (typeof this.$props.model === 'number') {
                    if (parseInt(this.valModel) !== parseInt(this.$props.model))
                        this.valModel = parseInt(this.$props.model);
                } else if (typeof this.$props.model === 'boolean') {
                    if (this.valModel != this.$props.model)
                        this.valModel = !!this.$props.model;
                } else {
                    if (this.valModel != this.$props.model)
                        this.valModel = this.$props.model;
                }
            },
            toggleCheck() {
                if (this.$props.disabled) return;
                if (typeof this.valModel === 'object' && Array.isArray(this.valModel))
                    this.handleArray();
                else if (typeof this.valModel === 'number') this.handleNumber();
                else if (typeof this.valModel === 'boolean') this.handleBoolean();
                else this.handleString();
                this.emitDirty();
            },
            emitDirty() {
                this.isDirty = true;
                this.$emit('update:dirty', this.isDirty);
            },
            handleArray() {
                let i = this.valModel.indexOf(this.val);
                if (i == -1) this.valModel.push(this.val);
                else this.valModel.splice(i, 1);
            },
            handleNumber() {
                this.valModel = (parseInt(this.valModel) === 1) ? 0 : 1;
            },
            handleBoolean() {
                this.valModel = !this.valModel;
            },
            handleString() {
                if (this.valModel === this.val) this.valModel = null;
                else this.valModel = this.val;
            },
        }
    }
</script>
<style lang="sass">
    .z-check-container
        margin: 10px 0 10px 0
        padding: 0 0 5px 0
        .md-caption
            display: block
            padding: 0
            margin: 0 0 10px 0
            font-size: 12px
            line-height: 16px
            font-weight: 500
            width: 100%
        .z-check
            margin-bottom: 6px
    .z-check
        input
            display: none
        label
            position: relative
            padding: 0 0 0 22px
            font-size: 12px
            line-height: 16px
            min-height: 16px
            display: inline-block
            &:before
                content: ''
                position: absolute
                display: block
                width: 16px
                height: 16px
                background: transparent
                border: 2px solid #C4C4C4
                overflow: hidden
                top: 0
                left: 0
                transition: 0.4s cubic-bezier(.25,.8,.25,1)
            &:after
                content: ''
                position: absolute
                display: block
                width: 5px
                height: 10px
                border: 2px solid transparent
                border-top: 0
                border-left: 0
                transform: rotate(45deg) scale3D(1,1,1)
                transition: 0.4s cubic-bezier(.25,.8,.25,1)
                left: 6px
                top: 2px
        input:checked + label
            &:before
                background: #448aff
                border-color: #448aff
            &:after
                border-color: #fff
        &.disabled
            input + label
                &:before
                    background: #F1F1F1
                    border-color: #C4C4C4
                &:after
                    border-color: transparent
            input:checked + label
                &:before
                    background: #8a8a8a
                    border-color: #8a8a8a
                &:after
                    border-color: #fff
    .z-check.is-dirty
        label
            color: #2196f3
</style>


// WEBPACK FOOTER //
// ZCheck.vue?4f0de460